import everouLogoHorizontal from "../_assets/icons/icon_baintex_logo_h_white.svg";
import everouLogoVertical from "../_assets/icons/logo_baintex_name_white_v1.svg";
import accesscloudLogo from "../_assets/icons/logo_accesscloud_white.svg";
import accesscloudHeaderBg from "../_assets/icons/header_bg_accesscloud.jpg";
import ai360accessLogo from "../_assets/icons/logo_ai360access_white.svg";
import ai360accessHeaderBg from "../_assets/icons/header_bg_ai360access.jpg";

export const BRAND_IDS = {
    EVEROU: "EVEROU",
    ACCESSCLOUD: "ACCESSCLOUD",
    AI360ACCESS: "AI360ACCESS",
};

export const BRANDS = {
    [BRAND_IDS.EVEROU]: {
        id: BRAND_IDS.EVEROU,
        name: "Baintex",
        productName: "Everou",
        hostnames: [],
        logoHorizontal: everouLogoHorizontal,
        logoVertical: everouLogoVertical,
        headerBackgroundImage: null,
        primaryHsl: "198, 100%, 45%",
        primaryLight1Hsl: "198, 100%, 78%",
        primaryLight2Hsl: "198, 100%, 95%",
        primaryDark1Hsl: "198, 100%, 36%",
    },
    [BRAND_IDS.ACCESSCLOUD]: {
        id: BRAND_IDS.ACCESSCLOUD,
        name: "AccessCloud",
        productName: "AccessCloud",
        hostnames: ["accesscloud.tech"],
        logoHorizontal: accesscloudLogo,
        logoVertical: accesscloudLogo,
        headerBackgroundImage: accesscloudHeaderBg,
        primaryHsl: "181, 72%, 19%",
        primaryLight1Hsl: "159, 87%, 28%",
        primaryLight2Hsl: "172, 50%, 92%",
        primaryDark1Hsl: "181, 75%, 13%",
    },
    [BRAND_IDS.AI360ACCESS]: {
        id: BRAND_IDS.AI360ACCESS,
        name: "AI360",
        productName: "AI360",
        hostnames: ["ai360access.com"],
        logoHorizontal: ai360accessLogo,
        logoVertical: ai360accessLogo,
        headerBackgroundImage: ai360accessHeaderBg,
        // UI accent (buttons, links, segmented selectors…) lifted from the
        // brandbook green for legibility on light surfaces. The header is the
        // brandbook image and does NOT use --colorPrimary, so it stays #002930.
        primaryHsl: "189, 100%, 22%",
        primaryLight1Hsl: "189, 70%, 33%",
        primaryLight2Hsl: "189, 45%, 92%",
        // Exact brandbook green #002930, kept for dark accents/hover.
        primaryDark1Hsl: "189, 100%, 9%",
        // Brandbook beige (#e1caae) — used as the login input accent so the
        // fields stand out on the dark login background.
        loginInputAccent: "#e1caae",
    },
};

export const DEFAULT_BRAND_ID = BRAND_IDS.EVEROU;
